import React from "react";
import InputControls from "../../../common/InputControls";
import { fieldsConfig } from "../../../../../configurations/discoverConfigs/commonFieldsConfig";

const CardHolderDetails = ({ formData, disableFields }) => (
  <div>
    <h4 className="bold">
      Card Holder Details <small>(Optional)</small>
    </h4>
    <div className="panel panel-default">
      <div className="panel-body">
        <div className="card-holder-details">
          <div className="row">
            {fieldsConfig.cardHolderDetails &&
              fieldsConfig.cardHolderDetails.fields &&
              fieldsConfig.cardHolderDetails.fields.map(
                (field, index) =>
                  field && (
                    <div key={index} className="col-sm-6">
                      <InputControls
                        field={field}
                        disableFields={disableFields}
                        formData={formData}
                      />
                    </div>
                  )
              )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CardHolderDetails;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/CreateCaseForms/CardHolderDetails.js